import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutes = () => {
  const local_data = JSON.parse(localStorage.getItem("userSession"));
  if (local_data) {
    const isAuthenticated = local_data.token;
    if (isAuthenticated) {
      return <Outlet />;
    } else {
      return <Navigate to="/" />;
    }
  } else {
    return <Navigate to="/" />;
  }
};

export default PrivateRoutes;
